module.exports = __webpack_public_path__ + "pc/img/work_detail2.73d2debd.png";